import script from "./component-default-navbar.vue?vue&type=script&setup=true&lang=js"
export * from "./component-default-navbar.vue?vue&type=script&setup=true&lang=js"

import "./component-default-navbar.vue?vue&type=style&index=0&id=4ef7a0ce&scoped=true&lang=scss"

import exportComponent from "C:\\FileServer\\vedwen\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ef7a0ce"]])

export default __exports__